import { useEffect } from 'react';

import Input from 'common/components/form/inputs/Input';
import { useFormState } from 'utils/hooks';

export const NameSynonym = ({ state, setSynonymIndex }) => {
  const { fields, changeField } = useFormState(state);

  useEffect(() => {
    if (fields.value) {
      setSynonymIndex(state.index);
    } else {
      setSynonymIndex(0);
    }
  }, [fields.value]);

  return <Input {...fields.value} onChange={changeField('value')} className="flex-fill me-1" />;
};

export const CodeSynonym = ({ state, setSynonymIndex }) => {
  const { fields, changeField } = useFormState(state);

  useEffect(() => {
    if (fields.value !== null) {
      setSynonymIndex(state.index);
    } else {
      setSynonymIndex(0);
    }
  }, [fields.value]);

  return <Input {...fields.value} onChange={changeField('value')} className="flex-fill me-1" />;
};
